import EmailTemplatePlaceholders from '../Components/EmailTemplatePlaceholders';

export const getEmailTemplateHtml = (
    title: string,
    thankYouMessage: string,
    bodyHtml: string,
    regards: string,
    candidateName: string,
    recruiterName: string,
    companyName: string,
    recruitmentName?: string,
    includeRecruiterName?: boolean,
) => {
    let thankYouMessageWithPlaceholders = `${thankYouMessage.replace(
        EmailTemplatePlaceholders.CompanyName,
        `${companyName}`,
    )}`;

    if (recruitmentName) {
        thankYouMessageWithPlaceholders = thankYouMessageWithPlaceholders.replace(
            EmailTemplatePlaceholders.RecruitmentName,
            recruitmentName,
        );
    }

    let html = `
            <p>${title} ${candidateName},</p>
            <p><br></p>
            <p>${thankYouMessageWithPlaceholders}</p>
            <p><br></p>
            ${bodyHtml}
            <p><br></p>
            <p>${regards}</p>
        `;

    if (includeRecruiterName) {
        html = `
            ${html}
            <p>${recruiterName}</p>
        `;
    }

    const withCompanyName = `
            ${html}
            <p>${companyName}</p>
        `;

    return withCompanyName;
};
